export class GetRenters {
    constructor() {
        this.handle = async () => {
            const apiUrl = process.env.REACT_APP_API_URL;
            try {
                const url = new URL(`/renters`, apiUrl);
                const response = await fetch(url.toString());
                const data = await response.json();
                return data;
            }
            catch (error) {
                return console.error(error);
            }
        };
    }
}
